import { apiGetAuth, apiPostAuth } from '@/utils/api'
import { API_JOURNAL_CONTRIBUTION } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  journal_contribution_list: {
    isLoading: false,
    data: {}
  },
  // Rekap agregat per company (1 baris/company per invoice) — tampilan utama.
  journal_company_list: {
    isLoading: false,
    data: {}
  },
  detail_journal_contribution: {
    isLoading: false,
    data: {}
  },
  data_modal_add_edit: {},
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false
  },
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  }
}

const mutations = {
  "SET_JOURNAL_CONTRIBUTION_LIST": (state, payload) => {
    state.journal_contribution_list = payload
  },
  "SET_DETAIL_JOURNAL_CONTRIBUTION": (state, payload) => {
    state.detail_journal_contribution = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  },
  // Patch satu row sync_status di list tanpa refetch (anti-flicker). Dipakai poll background sync.
  "SET_JOURNAL_ROW_SYNC_STATUS": (state, { journal_id, sync_status, sync_description }) => {
    const list = state.journal_contribution_list?.data?.data
    if (!Array.isArray(list)) return
    const row = list.find(item => item.id === journal_id)
    if (!row) return
    row.sync_status = sync_status
    if (sync_description !== undefined) row.sync_description = sync_description
  },
  "SET_JOURNAL_COMPANY_LIST": (state, payload) => {
    state.journal_company_list = payload
  },
  // Patch status agregat 1 baris company (key = company_id + invoice_number) tanpa refetch.
  "SET_JOURNAL_COMPANY_ROW_STATUS": (state, { company_id, invoice_number, sync_status_name, completed_participants }) => {
    const list = state.journal_company_list?.data?.data
    if (!Array.isArray(list)) return
    const row = list.find(item => item.company_id === company_id && item.invoice_number === invoice_number)
    if (!row) return
    if (sync_status_name !== undefined) row.sync_status_name = sync_status_name
    if (completed_participants !== undefined) row.completed_participants = completed_participants
  }
}

const actions = {
  async getJournalContributionList(context, payload) {
    try {
      context.commit('SET_JOURNAL_CONTRIBUTION_LIST', { isLoading: true })
      const response = await apiGetAuth(API_JOURNAL_CONTRIBUTION.LIST, payload)
      context.commit('SET_JOURNAL_CONTRIBUTION_LIST', {
        isLoading: false,
        data: response.data
      })
    } catch (err) {
      context.commit('SET_JOURNAL_CONTRIBUTION_LIST', {
        isLoading: false,
        data: false
      })
      notificationDanger(err)
    }
  },
  async getDetailJournalContribution(context, payload) {
    try {
      context.commit('SET_DETAIL_JOURNAL_CONTRIBUTION', { isLoading: true })
      const response = await apiGetAuth(API_JOURNAL_CONTRIBUTION.BY_ID(payload))
      context.commit('SET_DETAIL_JOURNAL_CONTRIBUTION', {
        isLoading: false,
        data: response.data
      })
    } catch (error) {
      context.commit('SET_DETAIL_JOURNAL_CONTRIBUTION', {
        isLoading: false,
        data: false
      })
      notificationDanger(error)
    }
  },
  async getJournalCompanyList(context, payload) {
    try {
      context.commit('SET_JOURNAL_COMPANY_LIST', { isLoading: true })
      const response = await apiGetAuth(API_JOURNAL_CONTRIBUTION.LIST_BY_COMPANY, payload)
      context.commit('SET_JOURNAL_COMPANY_LIST', { isLoading: false, data: response.data })
    } catch (err) {
      context.commit('SET_JOURNAL_COMPANY_LIST', { isLoading: false, data: false })
      notificationDanger(err)
    }
  },
  // Poll status agregat 1 company+invoice — balik 1 baris recap (atau null).
  async getJournalCompanyStatus(_context, { company_id, invoice_number }) {
    try {
      const response = await apiGetAuth(API_JOURNAL_CONTRIBUTION.LIST_BY_COMPANY, { company_id, invoice_number, limit: 1, page: 1 })
      const rows = response?.data?.data
      return Array.isArray(rows) && rows.length > 0 ? rows[0] : null
    } catch (err) {
      return null
    }
  },
  async getJournalSyncStatus(_context, payload) {
    // Lightweight poll for background sync — no commit (avoid table flicker), swallow transient errors.
    try {
      const response = await apiGetAuth(API_JOURNAL_CONTRIBUTION.BY_ID(payload))
      return response?.data?.data || null
    } catch (err) {
      return null
    }
  },
  async logDownloadFailure(_context, payload) {
    try {
      await apiPostAuth(API_JOURNAL_CONTRIBUTION.LOG_DOWNLOAD_FAILURE, payload)
    } catch (err) {
      // Swallow — best-effort logging. User already notified via notificationDanger.
    }
  }
}

const getters = {
  get_journal_contribution_list: state => {
    return state.journal_contribution_list
  },
  get_journal_company_list: state => {
    return state.journal_company_list
  },
  get_detail_journal_contribution: state => {
    return state.detail_journal_contribution
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter: state => {
    return state.meta_filter
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
